import React from 'react';
import { Translate } from 'react-redux-i18n';

type Props = {
  i18nKey?: string,
  label?: string,
  className?: string,
  children?: React.ReactNode,
};

export default function H4Title(
  {
    i18nKey,
    label,
    className,
    children,
  }: Props,
)
  : JSX.Element {
  return (
    <h4 className={`h4-background-container ${className || ''}`}>
      {
        i18nKey
          ? <Translate value={i18nKey} />
          : (children || label)
      }
      <div className="h4-title-background" />
    </h4>
  );
}
